// ===============================================================
// ---------------------------------------------------------------
// Dependencies
import { useEffect, useContext, Fragment, Suspense, lazy } from "react"

// Context
import AppContext from "../../Context/App/appContext"
import AppNavbar from "../Modules/AppNavbar"

// Modules
import Spinner from "../Modules/Spinner"
import Theme from "../Modules/Theme"

// Lazy Modules
const FAQTabs = lazy(() => import("../Modules/FAQTabs"))
const Footer = lazy(() => import("../Modules/Footer"))

// ===============================================================
const Help = () => {
	// ---------------------------------------------------------------
	// Context
	const appContext = useContext(AppContext)
	const { getFaqs, getAllFaqs, faqs } = appContext

	// ---------------------------------------------------------------
	// Scroll to top on load and get content
	useEffect(() => {
		window.scrollTo(0, 0)
		getFaqs()
		getAllFaqs()
		// eslint-disable-next-line
	}, [])

	return (
		<Fragment>
			<Suspense fallback={<Spinner />}>
				{faqs ? (
					<Theme id="help" className="help">
						<AppNavbar />
						<FAQTabs />
						<Footer />
					</Theme>
				) : (
					<Spinner />
				)}
			</Suspense>
		</Fragment>
	)
}

export default Help
